<template>
  <div class="dashboard-container">
    <div>
      <!-- Bootstrap Modal -->
      <div class="modal fade" id="confirmDeleteModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Konfirmasi Hapus</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              Apakah Anda yakin ingin menghapus kategori usia turnamen ini?
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Batal</button>
              <button type="button" class="btn btn-danger" @click="deleteCategory">Ya, hapus</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="loading"
      class="progress-bar"
      :style="{ width: progress + '%' }"
    ></div>
    <div class="mb-2 page-title">
      <i class="bi bi-people"></i> Kategori Usia
    </div>

    <div class="mb-3 d-flex flex-wrap gap-2 justify-content-between align-items-start">
      <DataToolbar
        v-model="searchQuery"
        placeholder="Cari kategori usia atau turnamen..."
        :mencari="loading"
        @search="cari"
      >
        <template #filters>
          <!--
            Turnamen yang sudah selesai disembunyikan secara bawaan.
            Datanya tidak dihapus - hanya tidak ikut ditampilkan, supaya
            daftar tidak dipenuhi acara tahun-tahun sebelumnya.
          -->
          <label class="saring-selesai">
            <input type="checkbox" v-model="termasukSelesai" @change="cari(searchQuery)" />
            Tampilkan turnamen selesai
          </label>
        </template>
      </DataToolbar>

      <router-link to="/admin/tournament-age-category/create" class="button button-primary">
        <i class="bi bi-plus-square"></i> Tambah
      </router-link>
    </div>

    <!-- Table to display navigation data -->
    <div class="table-responsive mt-3">
      <table class="table mb-0">
        <thead>
          <tr>
            <th>No</th>
            <th>Turnamen</th>
            <th>Kelompok Usia</th>
            <th>Aksi</th>
          </tr>
        </thead>
        <!-- Wrapper element with v-if -->
        <tbody v-if="tournamentAgeCategories.length > 0">  
          <tr v-for="(tournamentAgeCategory, index) in tournamentAgeCategories" :key="tournamentAgeCategory.id">
            <td>{{ index + 1 + (currentPage - 1) * perPage }}</td>
            <td class="kolom-turnamen">{{ tournamentAgeCategory.tournament?.name || '-' }}</td>
            <td>{{ tournamentAgeCategory.age_category.name }}</td>
            
            <td class="action-column">
              <div class="d-flex gap-2 justify-content-end">
          <MenuAksi v-slot="{ tutup }">
            <button type="button" class="aksi__item"
                    @click="tutup(); EditCategory(tournamentAgeCategory.id)">
              <i class="bi bi-pencil-square"></i> Ubah
            </button>
            <button type="button" class="aksi__item aksi__item--bahaya"
                    @click="tutup(); confirmDelete(tournamentAgeCategory.id)">
              <i class="bi bi-trash"></i> Hapus
            </button>
          </MenuAksi>
        </div>
            </td>
          </tr>
        </tbody>
        <!-- Fallback message when there is no data -->
        <tbody v-else>
          <tr>
            <td colspan="4" class="text-center">Belum ada data.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination Controls -->
    <div class="d-flex justify-content-end mt-4">
      <AppPagination
        :current-page="currentPage"
        :total-pages="totalPages"
        :prev-page-url="prevPageUrl"
        :next-page-url="nextPageUrl"
        @change-page="changePage"
      />
    </div>

  </div>
</template>

<script>
import axios from "axios";
import API from "@/config/api";
import DataToolbar from "@/components/ui/DataToolbar.vue";
import MenuAksi from "@/components/ui/MenuAksi.vue";
import AppPagination from "@/components/ui/AppPagination.vue";
import { Modal } from "bootstrap";
import { useToast } from "vue-toastification";

axios.defaults.baseURL = API.API_BASE_URL;

export default {
  name: "TournamentAgeCategoryList",

  components: { DataToolbar, MenuAksi, AppPagination },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      tournamentAgeCategories: [], // Array to hold paginated team members
      searchQuery: "",
      // Bawaan false: turnamen selesai disembunyikan.
      termasukSelesai: false,
      currentPage: 1, // Current page of results
      perPage: 10, // Results per page
      totalPages: 0, // Total number of pages
      prevPageUrl: null, // URL of the previous page
      nextPageUrl: null, // URL of the next page
      loading: false,
      progress: 0,
      selectedId: null,
      deleteModal: null,
    };
  },
  mounted() {
    const modalEl = document.getElementById("confirmDeleteModal");
    if (modalEl) {
      this.deleteModal = new Modal(modalEl);
    }
    this.loadTournamentAgeCategories(); // Load menu data when the component is mounted
  },
  methods: {
    /** Dipanggil DataToolbar setelah pengguna berhenti mengetik (350 ms). */
    cari(kata) {
      this.searchQuery = kata ?? '';
      this.currentPage = 1;
      this.loadTournamentAgeCategories(1);
    },

    async loadTournamentAgeCategories(page = 1) {
      this.loading = true;
      try {
        const response = await axios.get("/tournament-age-categories", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`, // Assumes token is in localStorage
          },
          params: {
            page,
            perPage: this.perPage,
            search: this.searchQuery.trim(),
            termasuk_selesai: this.termasukSelesai ? 1 : 0,
          },
        });
        const {
          current_page,
          last_page,
          data,
          next_page_url,
          prev_page_url,
        } = response.data;

        this.tournamentAgeCategories = data; // Assign team members
        this.currentPage = current_page; // Current page
        this.totalPages = last_page; // Total pages
        this.nextPageUrl = next_page_url; // Next page URL
        this.prevPageUrl = prev_page_url; // Previous page URL
        this.loading = false;
      } catch (error) {
        console.error("Error loading data:", error);
      }
    },

    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.loadTournamentAgeCategories(page);
      }
    },


    searchClasses() {
      this.currentPage = 1; // Reset to page 1 for new search
      this.loadTournamentAgeCategories();
    },

    async EditCategory(id) {
      this.$router.push({ name: "EditCategory", params: { id } });
    },

    confirmDelete(id) {
      this.selectedId = id;
      if (this.deleteModal) {
        this.deleteModal.show();
      }
    },

    async deleteCategory() {
      try {
        await axios.delete(`/tournament-age-categories/${this.selectedId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        });
        this.toast.success("Kategori usia turnamen berhasil dihapus!");
        if (this.deleteModal) {
          this.deleteModal.hide();
        }
        this.loadTournamentAgeCategories(this.currentPage);
      } catch (error) {
        if (this.deleteModal) {
          this.deleteModal.hide();
        }
        const msg = error.response?.data?.message || error.response?.data?.error || "Gagal menghapus kategori usia.";
        this.toast.error(msg);
      }
    },
  },
  computed: {
    prevPageExists() {
      return this.currentPage > 1;
    },
    nextPageExists() {
      return this.currentPage < this.totalPages;
    },
  },
};
</script>

<style scoped>
.saring-selesai {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  font-size: var(--text-sm);
  color: var(--text-secondary);
  white-space: nowrap;
  cursor: pointer;
}

.saring-selesai input { width: 16px; height: 16px; accent-color: var(--accent); }


.table th,
.table td {
  padding: 10px;
}






.form-control {
  width: 250px;
}

.progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 5px;
  background: var(--grad-flame);
  animation: loader-animation 1.5s infinite;
}

/* Animasi garis loader */
@keyframes loader-animation {
  0% {
    width: 0;
    background: var(--grad-flame); /* Warna awal */
  }
  50% {
    width: 50%;
    background: var(--grad-flame); /* Warna saat animasi */
  }
  100% {
    width: 100%;
    background: var(--grad-flame);
  }
}
</style>
